// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"20":"889db586","321":"739a0d0e","734":"80c53cf6","978":"ae3f8089"}[chunkId] + ".js";
};